import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useTheme } from '@mui/material/styles';

/**
 * Replacement for the removed `withTheme` HOC.
 *
 * MUI v9 exposes a throwing migration stub at `@mui/material/styles`, while
 * tss-react does not provide a withTheme export. This wrapper keeps legacy
 * class components working by injecting the active MUI theme as a prop.
 */
const withTheme = WrappedComponent => {
  const WithTheme = React.forwardRef(function WithTheme(props, ref) {
    const theme = useTheme();
    return <WrappedComponent {...props} theme={theme} ref={ref} />;
  });

  WithTheme.displayName = `withTheme(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return hoistNonReactStatics(WithTheme, WrappedComponent);
};

export { withTheme };
export default withTheme;
